// Effect Managers
import { put, call, fork } from 'redux-saga/effects'

// Exports
export default function composeUpdate ({
  state,
  actionCreators,
  handler,
}) {
  const update = function *update (
    { url, queryParams, id: maybeId, model } = {},
    { block = true, meta = {} } = {}
  ) {
    const id = maybeId || model.id

    if (!block && state.get().watch.update) {
      const action = actionCreators.update({
        url,
        id,
        queryParams,
        model,
      }, {
        meta,
      })

      yield put(action)
    } else {
      const result = yield call(handler, { url, id, queryParams, model }, meta)
      return result
    }
  }

  const updateNonBlocking = function *updateNonBlocking (
    payload = {},
    { meta = {} } = {}
  ) {
    yield fork(update, payload, {
      block: false,
      meta,
    })
  }

  return {
    update,
    updateNonBlocking,
  }
}
